import { Location } from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DefaultComponent} from "../../shared/components/default.component";
import {IonModal, LoadingController, ToastController} from "@ionic/angular";
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {AuthenticationService} from "../../shared/_services/authentication.service";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage extends DefaultComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  isLoading = false;
  resetForm: FormGroup;
   showErrors = false;
    key: any;

  constructor(
      private fb: FormBuilder,
      private loadingCtrl: LoadingController,
      private authenticationService: AuthenticationService,
      router: Router,
      activatedRoute: ActivatedRoute,
      sharedRoutesService: SharedRoutesService,
      toastController: ToastController
  ) {
    super(router, activatedRoute, sharedRoutesService,toastController);
  }

  ngOnInit() {
    this.key = this.activatedRoute.snapshot.paramMap.get('key');
    this.resetForm = this.fb.group({
      new_password: ['', [Validators.required, Validators.minLength(7)]],
      new_password_confirmation: ['', Validators.required],
    }, {
      validators: this.matchPasswords('password', 'password_confirmation')
    });
  }


  matchPasswords(passwordKey: string, confirmPasswordKey: string) {
    return (group: AbstractControl): ValidationErrors | null => {
      const password = group.get(passwordKey)?.value;
      const confirmPassword = group.get(confirmPasswordKey)?.value;
      return password === confirmPassword ? null : { passwordsMismatch: true };
    };
  }

  onResetClick() {
    this.isLoading = true;
    const queryParams = {
      new_password : this.resetForm.get('new_password').value,
      new_password_confirmation : this.resetForm.get('new_password_confirmation').value,
      token : this.key
    }
    this.authenticationService.changePassword(queryParams)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
            (response) => {
              this.isLoading = false;
              console.log("Recover response:", response);
              this.presentErrorToast(response.message); // success message from backend
              // Navigate after 2 seconds
              setTimeout(() => {
                this.router.navigate(['/authentication/login']);
              }, 2000);
            },
            (error) => {
              this.isLoading = false;
              this.showErrors = true;
              console.error("Recover error:", error);
              this.presentErrorToast(error.message); // error message from backend
              setTimeout(() => {
                this.router.navigate(['/authentication/login']);
              }, 2000);
            }
        );
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

}
